function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.67 1.75c-.5 0-.92.4-.92.9v24.7c0 .5.42.9.92.9h18.66c.5 0 .92-.4.92-.9V9.9a.88.88 0 0 0-.35-.71l-7.36-7.17s-.04-.04-.06-.05c-.02-.01-.03-.02-.04-.03l-.03-.02-.07-.07-.06-.03a.408.408 0 0 0-.07-.02s-.04-.01-.05-.02l-.05-.03H5.67Zm.92 24.7V3.55h9.39V9.9c0 .5.42.9.92.9h6.52v15.65H6.58ZM17.82 9V4.8l4.3 4.19h-4.3Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};

export default SvgDocument;